<div>
  <div class="mb-3">
    <label for="deviceid" class="form-label">Device ID</label>
    <input [(ngModel)]="deviceid" type="text" class="form-control" name="deviceid"
    [ngClass]=" {'validated': deviceid.length == 17, 'not-validated' : deviceid.length != 17 }">
  </div>
  <div class="mb-3">
    <label for="description" class="form-label">Description</label>
    <input [(ngModel)]="description" type="text" class="form-control" name="description">
  </div>
  <div class="mb-3">
    <label for="department" class="form-label">Department</label>
    <select class="form-control" aria-label="Select a department" name="department" [(ngModel)]="department_id"
    [ngClass]=" {'validated': department_id !=0, 'not-validated' : department_id==0 }">
      <option value="0" selected>Please select a department</option>
      <option *ngFor="let item of departments[0]" value="{{item.id}}">{{item.name}}</option>
    </select>
  </div>
  <button (click)="save()" class="btn btn-primary">Save</button>
</div>